import HubScheduleNavItem from './HubScheduleNavItem';

export default HubScheduleNavItem;
